import React, { useRef } from 'react';
import Datagrid, { Column, Selection, Scrolling, Paging, FilterRow, GroupPanel, Grouping } from 'devextreme-react/data-grid';
import { useScreenSize } from '../../../../utils/media-query';

interface FilterStudiesDataGridProps {
  studiesDataSource: any;
  studiesDropDownValue: number[];
  onStudiesSelectionChanged: (e: any) => void;
  onStudiesRowDblClick: (e: any) => void;
  studiesSearchValue: string;
  onStudiesSearchValueChanged: (e: any) => void;
  onStudiesKeyDown: (e: any) => void;
  setIsStudiesDropDownOpened: (opened: boolean) => void;
  refDropDownStudies?: React.RefObject<any>;
}

export const FilterStudiesDataGrid: React.FC<FilterStudiesDataGridProps> = ({ 
  studiesDataSource, 
  studiesDropDownValue, 
  onStudiesSelectionChanged, 
  onStudiesRowDblClick, 
  studiesSearchValue, 
  onStudiesSearchValueChanged, 
  onStudiesKeyDown, 
  setIsStudiesDropDownOpened, 
  refDropDownStudies 
}) => {
  const { isSmall, isXSmall } = useScreenSize();
  const refDataGridStudies = useRef<Datagrid>(null);

  const gridHeight = isXSmall || isSmall ? '70vh' : 400;
  const containerStyle =
    isXSmall || isSmall
      ? {
          position: 'fixed' as const,
          top: 0,
          left: 0,
          width: '100vw',
          height: '100vh',
          backgroundColor: 'white',
          zIndex: 1000,
          display: 'flex',
          flexDirection: 'column' as const,
        }
      : {};

  return (
    <div style={containerStyle}>
      {/* Header para móviles con botón cerrar */}
      {(isXSmall || isSmall) && (
        <div
          style={{
            padding: '10px 15px',
            borderBottom: '1px solid #ddd',
            backgroundColor: '#f8f9fa',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}>
          <h3 style={{ margin: 0, fontSize: '16px', fontWeight: 'bold' }}>Seleccionar Estudio</h3>
          <button
            onClick={() => setIsStudiesDropDownOpened(false)}
            style={{
              background: 'none',
              border: 'none',
              fontSize: '18px',
              cursor: 'pointer',
              padding: '5px',
              borderRadius: '3px',
            }}>
            ×
          </button>
        </div>
      )}

      {/* Barra de búsqueda */}
      <div
        style={{
          padding: isXSmall || isSmall ? '15px 20px' : '10px',
          borderBottom: '1px solid #ddd',
          backgroundColor: isXSmall || isSmall ? '#f8f9fa' : 'white',
        }}>
        <input
          id='filter-studies-search-input'
          type='text'
          placeholder='Escriba para buscar estudios...'
          value={studiesSearchValue}
          onChange={(e) => onStudiesSearchValueChanged({ value: e.target.value })}
          onKeyDown={(e) => onStudiesKeyDown({ event: e })}
          style={{
            width: '100%',
            padding: '8px 12px',
            border: '1px solid #ddd',
            borderRadius: '4px',
            fontSize: '14px',
            outline: 'none',
            fontFamily: 'inherit',
          }}
          autoFocus
        />
        {/* Instrucciones para móviles */}
        {(isXSmall || isSmall) && (
          <div
            style={{
              marginTop: '8px',
              fontSize: '12px',
              color: '#666',
              textAlign: 'center',
            }}>
            Use ↑↓ para navegar • Enter para seleccionar • Doble toque para seleccionar
          </div>
        )}
      </div>

      <div style={{ flex: 1, overflow: 'hidden' }}>
        <Datagrid 
          ref={refDataGridStudies} 
          dataSource={studiesDataSource} 
          height={gridHeight} 
          hoverStateEnabled={true} 
          selectedRowKeys={studiesDropDownValue} 
          onSelectionChanged={onStudiesSelectionChanged} 
          onRowClick={onStudiesRowDblClick} 
          showBorders={false} 
          keyExpr='Es_Id' 
          wordWrapEnabled={false} 
          columnAutoWidth={true} 
          rowAlternationEnabled={true}
        >
          <Selection mode='single' />
          <Scrolling mode='virtual' rowRenderingMode='virtual' />
          <Paging enabled={false} />
          <FilterRow visible={false} />
          <GroupPanel visible={false} />
          <Grouping autoExpandAll={true} />
          <Column dataField='SysA_AreasAnalisis.Aa_Nombre' caption='Área' groupIndex={0} />
          <Column dataField='Es_Codigo' caption='Código' width={isXSmall || isSmall ? 80 : 100} minWidth={60} />
          <Column dataField='Es_Nombre' caption='Estudio' minWidth={isXSmall || isSmall ? 200 : 250} />
          <Column dataField='Es_Id' caption='ID' width={isXSmall || isSmall ? 60 : 80} visible={false} />
        </Datagrid>
      </div>
    </div>
  );
};
